import { RUN_PROMPTBOOK_DOCS_URL } from "@/constants";
import { Button, Flex, Link, Menu, MenuButton, MenuList, Text } from "@chakra-ui/react";
import { Editor } from "@monaco-editor/react";
import { Icon, MenuItem } from "@pufflig/prompt-studio-ui";
import { useState } from "react";
import { generateCodeSnippet } from "./generateCodeSnippet";
import { Schema } from "./types";

interface CodeSnippetProps {
  requestSchema: Schema;
  responseSchema: Schema;
  deploymentId: string;
  workspaceKey: string;
}

export const CodeSnippet = (props: CodeSnippetProps) => {
  const { deploymentId, workspaceKey, requestSchema, responseSchema } = props;
  const [selectedFormat, selectFormat] = useState("cURL");
  return (
    <Flex direction="column" gap="1">
      <Flex alignItems="center" justifyContent="space-between">
        <Text textStyle="label/L/medium" marginBottom="0.5">
          Code Snippet
        </Text>
        <Menu>
          <MenuButton size="sm" as={Button} rightIcon={<Icon size="sm" name="arrow-down-1" />}>
            {selectedFormat}
          </MenuButton>
          <MenuList>
            <MenuItem primaryLabel="cURL" onClick={() => selectFormat("cURL")} />
            <MenuItem primaryLabel="OpenAPI" onClick={() => selectFormat("OpenAPI")} />
          </MenuList>
        </Menu>
      </Flex>
      <Editor
        theme="vs-dark"
        height="200px"
        language={selectedFormat === "cURL" ? "shell" : "yaml"}
        options={{
          readOnly: true,
          dropIntoEditor: {
            enabled: false,
          },
          wordWrap: "on",
          minimap: { enabled: false },
        }}
        value={generateCodeSnippet(selectedFormat, deploymentId, workspaceKey, requestSchema, responseSchema)}
      />
      <Link
        textStyle="label/S/medium"
        color="foreground.secondary"
        display="flex"
        alignItems="center"
        gap="1"
        target="blank"
        href={`${RUN_PROMPTBOOK_DOCS_URL}`}
      >
        <Button size="sm" leftIcon={<Icon name="arrow-up" size="sm" />} variant="ghost">
          View Documentation
        </Button>
      </Link>
    </Flex>
  );
};
